/** @jsx jsx */
import { useContext } from 'react';
import { Box, Flex, Heading, Text, Button, jsx } from 'theme-ui';
import { IoIosClose } from 'react-icons/io';
import { CartContext } from '../../provider/cart-provider';
import styles from './cart.style';

const Cart: React.FunctionComponent<{ onClick?: () => void }> = ({
	onClick,
	children,
}) => {
	const { store } = useContext(CartContext);
	const { checkout } = store;
	const handleCheckout = () => {
		window.open(checkout.webUrl);
	};
	const getPrice = (price) =>
		Intl.NumberFormat(undefined, {
			currency: price.currencyCode,
			minimumFractionDigits: 2,
			style: 'currency',
		}).format(parseFloat(price && price.amount ? price.amount : 0));

	return (
		<Box sx={styles.wrapper}>
			<Heading as="h2" sx={styles.title}>
				Cart
				<Button variant="text" onClick={onClick}>
					<IoIosClose />
				</Button>
			</Heading>

			<Flex sx={styles.totalPrice}>
				<Box>
					<Text>Total Amount:</Text>
					<Heading as="h4">
						{checkout.totalPriceV2 && getPrice(checkout.totalPriceV2)}
					</Heading>
				</Box>
			</Flex>

			<Box sx={styles.cartItems}>{children}</Box>

			<Box sx={styles.buttonStyle}>
				<Button
					onClick={handleCheckout}
					disabled={checkout?.lineItems.length === 0}
				>
					Proceed to checkout
				</Button>
			</Box>
		</Box>
	);
};

export default Cart;
